import { ENVS, JURISDICTIONS, LANG_COOKIE_NAME, LANG_ISO_CODES } from '../constants';

declare global {
  interface Window {
    WH: {
      sportsbook?: {
        frontEndConfig: {
          overlayIntegrationEnabled: boolean;
        };
        lang?: string;
      };
    };
    docCookies?: {
      getItem(key: string): string | undefined;
    };
  }
}

const DEFUALT_LANG = LANG_ISO_CODES.EN;
const LANGS_MAP: Record<string, string> = {
  ru: LANG_ISO_CODES.RU,
  ja: LANG_ISO_CODES.JP,
  el: LANG_ISO_CODES.GR,
  [LANG_ISO_CODES.DE]: LANG_ISO_CODES.DE,
  [LANG_ISO_CODES.EN]: LANG_ISO_CODES.EN,
  [LANG_ISO_CODES.RU]: LANG_ISO_CODES.RU,
  [LANG_ISO_CODES.GR]: LANG_ISO_CODES.GR,
  [LANG_ISO_CODES.JP]: LANG_ISO_CODES.JP,
};

declare global {
  interface Window {
    WH: {
      sportsbook?: {
        frontEndConfig: {
          overlayIntegrationEnabled: boolean;
        };
        lang?: string;
      };
    };
    docCookies?: {
      getItem(key: string): string | undefined;
    };
  }
}

export function getCurrentScriptBasePath() {
  const currentScript = document.currentScript as HTMLScriptElement;

  const scriptEl =
    currentScript && currentScript.src.includes('wm.integration.js') ? currentScript : findMatchingScript();

  return scriptEl ? scriptEl.src.replace('wm.integration.js', '') : null;
}

function findMatchingScript(): HTMLScriptElement | undefined {
  const scripts = [...document.getElementsByTagName('script')];
  return scripts.find((script) => !!(script.src && script.src.includes('wm.integration.js')));
}

export function getEnv() {
  // @ts-ignore
  if (typeof MOCKED_ENV !== 'undefined') {
    // @ts-ignore
    return MOCKED_ENV;
  }
  const domain = window.location.host.split('.')[1];
  const ppPostfixMatch = domain.match(/^.*-(\w{2,}\d)$/);

  if (ppPostfixMatch === null) {
    return ENVS.PROD;
  }

  switch (ppPostfixMatch[1]) {
    case 'pp1':
      return ENVS.PP1;
    case 'pp2':
      return ENVS.PP2;
    case 'pp3':
      return ENVS.PP3;
    case 'pt1':
      return ENVS.PT1;
    default:
      throw new Error('Failed to determine environment');
  }
}

export function getJurisdiction() {
  // @ts-ignore
  if (typeof MOCKED_JUR !== 'undefined') {
    // @ts-ignore
    return MOCKED_JUR;
  }

  const tld = window.location.host.split('.')[2];

  switch (tld) {
    case 'com':
      return JURISDICTIONS.COM;
    case 'es':
      return JURISDICTIONS.ES;
    case 'it':
      return JURISDICTIONS.IT;
    default:
      throw new Error('Failed to determine jurisdiction');
  }
}

export function getProjectName() {
  const jurisdiction = getJurisdiction();

  switch (jurisdiction) {
    case JURISDICTIONS.COM:
      return 'sportsbook';
    case JURISDICTIONS.ES:
      return 'sportsbook_es';
    case JURISDICTIONS.IT:
      return 'sportsbook_it';
    default:
      return 'sportsbook';
  }
}

export function getLocale() {
  if (window.WH && window.WH.sportsbook && window.WH.sportsbook.lang) {
    return window.WH.sportsbook.lang;
  }

  const locale =
    window.docCookies && typeof window.docCookies.getItem === 'function'
      ? window.docCookies.getItem(LANG_COOKIE_NAME)
      : getCookie(LANG_COOKIE_NAME);

  if (!locale) {
    throwAsync(`Failed to determine locale. Using ${DEFUALT_LANG} as a fallback`);
    return DEFUALT_LANG;
  }

  return LANGS_MAP[locale] || locale;
}

function getCookie(name: string): string | undefined {
  const langDefinition = window.document.cookie
    .split(';')
    .map((k) => k.split('='))
    .find((k) => k[0].trim() === name);

  return langDefinition ? langDefinition[1] : undefined;
}

// SB doesn't allow to use console, so if we want to notify developers about issues, we should throw
// async throw is used not to break current event loop
async function throwAsync(error: string) {
  return Promise.reject(error);
}

export function includeHiddenrMarketsJourney(jurisdiction: string, environment: string) {
  return [JURISDICTIONS.COM].includes(jurisdiction) && [ENVS.PP2].includes(environment);
}

export function getMarketingPreferencePageUrl(jurisdiction: string, environment: string) {
  const env = environment === 'prod' ? '' : `-${environment}`;
  const locale = getLocale();

  return `https://sports.williamhill${env}.${jurisdiction}/betting/${locale}?myAccountView=personalDetailsMarketing`;
}
